import { render, staticRenderFns } from "./PuntoItemCard.vue?vue&type=template&id=401d1c7b&scoped=true"
import script from "./PuntoItemCard.vue?vue&type=script&lang=js"
export * from "./PuntoItemCard.vue?vue&type=script&lang=js"
import style0 from "./PuntoItemCard.vue?vue&type=style&index=0&id=401d1c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d1c7b",
  null
  
)

export default component.exports